module.exports = {
	"1": [
		"Alexander Hamilton",
		"#9541c8"
	],
	"2": [
		"Aaron Burr, Sir",
		"#35a993"
	],
	"3": [
		"My Shot",
		"#35a993"
	],
	"4": [
		"The Story of Tonight",
		"#51b6c9"
	],
	"5": [
		"The Schuyler Sisters",
		"#cc77aa"
	],
	"6": [
		"Farmer Refuted",
		"#35a993"
	],
	"7": [
		"You'll be Back",
		"#cc373c"
	],
	"8": [
		"Right Hand Man",
		"#005b9d"
	],
	"9": [
		"A Winter's Ball",
		"#9541c8"
	],
	"10": [
		"Helpless",
		"#51addf"
	],
	"11": [
		"Satisfied",
		"#35a993"
	],
	"12": [
		"The Story of Tonight (Reprise)",
		"#35a993"
	],
	"13": [
		"Wait for It",
		"#9541c8"
	],
	"14": [
		"Stay Alive",
		"#35a993"
	],
	"15": [
		"Ten Duel Commandments",
		"#35a993"
	],
	"16": [
		"Meet Me Inside",
		"#005b9d"
	],
	"17": [
		"That Would be Enough",
		"#51addf"
	],
	"18": [
		"Guns and Ships",
		"#008698"
	],
	"19": [
		"History Has Its Eyes On You",
		"#005b9d"
	],
	"20": [
		"Yorktown (The World Turned Upside Down)",
		"#35a993"
	],
	"21": [
		"What Comes Next",
		"#cc373c"
	],
	"22": [
		"Dear Theodosia",
		"#9541c8"
	],
	"23": [
		"Non-Stop",
		"#9541c8"
	],
	"24": [
		"What'd I Miss?",
		"#e0765a"
	],
	"25": [
		"Cabinet Battle #1",
		"#35a993"
	],
	"26": [
		"Take a Break",
		"#51addf"
	],
	"27": [
		"Say No to This",
		"#35a993"
	],
	"28": [
		"The Room Where It Happens",
		"#9541c8"
	],
	"29": [
		"Schuyler Defeated",
		"#9541c8"
	],
	"30": [
		"Cabinet Battle #2",
		"#e0765a"
	],
	"31": [
		"Washington on Your Side",
		"#e0765a"
	],
	"32": [
		"One Last Time",
		"#005b9d"
	],
	"33": [
		"I Know Him",
		"#cc373c"
	],
	"34": [
		"The Adams Administration",
		"#9541c8"
	],
	"35": [
		"We Know",
		"#35a993"
	],
	"36": [
		"Hurricane",
		"#35a993"
	],
	"37": [
		"The Reynolds Pamphlet",
		"#e0765a"
	],
	"38": [
		"Burn",
		"#51addf"
	],
	"39": [
		"Blow Us All Away",
		"#6ddbc4"
	],
	"40": [
		"Stay Alive (Reprise)",
		"#51addf"
	],
	"41": [
		"It's Quiet Uptown",
		"#35a993"
	],
	"42": [
		"The Election of 1800",
		"#e0765a"
	],
	"43": [
		"Your Obedient Servant",
		"#9541c8"
	],
	"44": [
		"Best of Wives and Best of Women",
		"#51addf"
	],
	"45": [
		"The World Was Wide Enough",
		"#9541c8"
	],
	"46": [
		"Who Lives, Who Dies, Who Tells Your Story",
		"#51addf"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/song_list.json
 ** module id = 214
 ** module chunks = 0
 **/